<template>
    <div>
        <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>

        <b-form @submit.stop.prevent="guardar">
            <b-container fluid>

                <fieldset>
                    <legend>Datos de la clínica</legend>
                    <b-row align-v="center">

                        <b-col cols="6">
                            <b-form-group align="left">
                                <label>Zona precios
                                    <validacion/>
                                </label>
                                <b-input-group size="sm" class="mb-2">
                                    <v-select
                                            style="width: 100%;"
                                            label="nombreZona"
                                            :options="opcionesPreciosFiltro"
                                            :reduce="(val) => val.idPrecio"
                                            v-model="$v.objGuardar.idPrecio.$model"
                                            placeholder="Selecciona un precio"

                                            :filterable="false"
                                            @search="filtroOpcionesPrecios"

                                    ></v-select>
                                    <validacion
                                            v-if="$v.objGuardar.idPrecio.$dirty && ($v.objGuardar.idPrecio.$invalid || $v.objGuardar.idPrecio.$error == 'true')"
                                            texto="Selecciona un precio"/>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                    </b-row>
                </fieldset>
            </b-container>
            <b-button id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"
                      v-if="$localStorageService.can('BO_28_clini_zona')"></b-button>
        </b-form>
    </div>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "altaClinica",
        components: {},
        props: {
            clinicaOriginal: Object
        },
        mixins: [validationMixin],
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                loading: false,
                mostrarModal: false,

                opcionesPrecios: [],
              opcionesPreciosFiltro: [],

                objGuardar: {
                    idClinica: null,
                    idPrecio: null,
                    idUbicacion: null,
                    idZona: null,
                    idKcli: null,
                    kRegion: null,
                    kunitProd: null,
                    kSubClient: null,
                    idTipoClinica: null,
                    idCategoria: null,
                    strRFC: null,
                    blnMercadoPago: false,
                    blnTransferenciaElectronica: false,
                    blnSeccionNinos: false,
                    idCrm: null,
                    idTipoSdi: null,
                    codigoPostal: null,
                    calle: null,
                    noExterior: null,
                    noInterior: null,
                    idEstado: null,
                    municipio: null,
                    colonia: null,
                    tel1: null,
                    tel2: null,
                    tel3: null,
                    blnTurismoMedico: false,
                    strMapa: ''
                }
            };
        },
        validations: {
            objGuardar: {
                idPrecio: {required}
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();

            this.cargarCatalagos();
            this.$nextTick(() => {
                this.$v.$reset()
            });
            this.crearClinica();
        },
        methods: {
          filtroOpcionesPrecios(busqueda, loading){
            loading(true)
            let seach = busqueda.trim()
            this.opcionesPreciosFiltro = this.opcionesPrecios.filter(em => {
              return em.nombreZona.toLowerCase().includes(seach.toLowerCase())}
            )
            loading(false)
          },
            validateState(name) {
                const {$dirty, $error} = this.$v.objGuardar[name];
                return $dirty ? !$error : null;
            },
            cargarCatalagos() {
                this.opcionesPrecios = [];
                this.loading = true;

                this.$http.get(this.$api + "catalogos/listaPrecios").then(response => {
                        if (response.data.data) {
                            this.opcionesPrecios = response.data.data
                          this.opcionesPreciosFiltro = this.opcionesPrecios;
                        }
                    }
                ).finally(()=>{this.loading= false});
            },
            crearClinica() {
                this.objGuardar = JSON.parse(JSON.stringify(this.clinicaOriginal));
            },
            guardar() {

                this.$v.objGuardar.$touch();
                if (this.$v.objGuardar.$anyError) {
                    return;
                }

              this.objGuardar.opcionGuardar = 3;

                this.loading = true;
                this.$http
                    .post(this.$api + "catalogos/crearClinica", this.objGuardar)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Clinica registrada correctamente ",
                                showConfirmButton: false,
                                timer: 3500,
                            });

                            this.$nextTick(() => {
                                this.$v.$reset()
                            });

                            this.$emit("actualizar", this.objGuardar.strNombre);
                            this.objGuardar = {};
                        }
                    }).catch((error)=>{
                  console.error(error);
                    this.$swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrio un error al registrar la clínica",
                        showConfirmButton: false,
                        timer: 3500,
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

    };
</script>
